/**
 * Screen 3 - Your goal
 */
import classnames from 'classnames';
import React, { PropTypes } from 'react';
import ButtonNext from './ButtonNext';
import ButtonPrevious from './ButtonPrevious';

function YourGoal({
  nextStep,
  paragraphData,
  previousStep,
  readingList,
  resultStatedGoal,
  setResult,
  stateOfReadiness,
}) {
  const {
    fieldActionExampleGoal,
    fieldActionStageStep,
    fieldActionStageSummary,
    fieldContemplationExampleGoal,
    fieldContemplationStageStep,
    fieldContemplationStageSummar,
    fieldMaintenanceExampleGoal,
    fieldMaintenanceStageStep,
    fieldMaintenanceStageSummary,
    fieldPreContemplationStageSt,
    fieldPreContemplationSummary,
    fieldPreparationExampleGoal,
    fieldPreparationStageStep,
    fieldPreparationStageSummary,
    fieldText,
    fieldTitle,
  } = paragraphData;
  let exampleGoal;
  let isPreContemplation = false;
  let stageStep;
  let stageSummary;
  const updateGoal = (evt) => {
    const newGoal = evt.target.value;
    setResult({ resultStatedGoal: newGoal });
  };
  // Set the stage summary and next step based on the state of readiness
  if (stateOfReadiness === 'pre-contemplation') {
    stageSummary = fieldPreContemplationSummary[0].value;
    stageStep = fieldPreContemplationStageSt[0].value;
    isPreContemplation = true;
  } else if (stateOfReadiness === 'contemplation') {
    exampleGoal = fieldContemplationExampleGoal[0].value;
    stageSummary = fieldContemplationStageSummar[0].value;
    stageStep = fieldContemplationStageStep[0].value;
  } else if (stateOfReadiness === 'action') {
    exampleGoal = fieldActionExampleGoal[0].value;
    stageSummary = fieldActionStageSummary[0].value;
    stageStep = fieldActionStageStep[0].value;
  } else if (stateOfReadiness === 'preparation') {
    exampleGoal = fieldPreparationExampleGoal[0].value;
    stageSummary = fieldPreparationStageSummary[0].value;
    stageStep = fieldPreparationStageStep[0].value;
  } else if (stateOfReadiness === 'maintenance') {
    exampleGoal = fieldMaintenanceExampleGoal[0].value;
    stageSummary = fieldMaintenanceStageSummary[0].value;
    stageStep = fieldMaintenanceStageStep[0].value;
  }
  return (
    <div
      className={classnames({
        'goal--step-three': true,
      })}
    >
      <h4>
        {fieldTitle[0].value}
      </h4>
      <div
        className="description"
        dangerouslySetInnerHTML={{
          __html: fieldText[0].value,
        }}
      />
      <div
        className={classnames({
          boxes: true,
        })}
      >
        <div
          dangerouslySetInnerHTML={{
            __html: stageSummary,
          }}
        />
        <div
          dangerouslySetInnerHTML={{
            __html: stageStep,
          }}
        />
      </div>
      {isPreContemplation ?
        <div>
          <h4>
            Articles to get you started
          </h4>
          <div
            dangerouslySetInnerHTML={{
              __html: readingList[0].fieldReadingList,
            }}
          />
        </div>
      :
        <div>
          <h5>
            Type your goal
          </h5>
          <div>
            <textarea
              defaultValue={resultStatedGoal}
              onChange={updateGoal}
              placeholder={exampleGoal}
            />
          </div>
          <ButtonPrevious
            previousStep={previousStep}
          />
          <ButtonNext
            disabled={!resultStatedGoal}
            nextStep={nextStep}
          />
          <div
            style={{
              fontSize: '16px',
              color: '#aaa',
            }}
          >
            Step 3 of 10
          </div>
        </div>
      }
    </div>
  );
}

YourGoal.propTypes = {
  nextStep: PropTypes.func,
  paragraphData: PropTypes.shape({}),
  previousStep: PropTypes.func,
  readingList: PropTypes.arrayOf(PropTypes.shape({})),
  resultStatedGoal: PropTypes.string,
  setResult: PropTypes.func,
  stateOfReadiness: PropTypes.string,
};

export default YourGoal;



// WEBPACK FOOTER //
// js/src/goals/YourGoal.js